import csiAction from "csi/action";
import Action from "csi/def/Action";
import { getImageData } from "csi/model/image";
import { C8Node, ICache } from "csi/typings";

/**
 * Open image lightbox without a view reference (from React)
 * @param {Node} imageNode
 * @param {Cache} cache
 * @param {boolean} [restrictEdit]
 */
export function openLightbox(imageNode: C8Node, cache: ICache, restrictEdit?: boolean): void {
	const imageData = getImageData(imageNode);

	const action = Object.assign(new Action(), {
		classController: "csi/image/LightGalleryController",
		m_id: "Lightbox",
	});

	const params = {
		restrictEdit,
		m_cache: cache,
		m_urlNode: imageData.url,
		_getImages: () => [[imageData], 0],
	};

	csiAction.invoke(null, document.body, action, params);
}
